import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.json.stringify.js";
// import { getLoginRequest } from '../http/msalMethods'
import { getAllUsersApi, createUserApi, updateAccountApi, deleteUserApi } from '../api';

import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  name: 'UserManage',
  data: function data() {
    return {
      // selectValue: {
      //   name: '帳號',
      //   filter: 'account'
      // },
      selectedFilter: {
        text: '帳號',
        value: 'account'
      },
      id: '',
      operator: '',
      managerRole: '',
      isLoadingUpdate: false,
      modalTitle: '',
      loadingData: false,
      isOpenFactoryCheckBox: false,
      factoryCheckBoxFilterInput: '',
      isOpenDemoCheckBox: false,
      demoCheckBoxFilterInput: '',
      searchInput: '',
      factorySelect: [],
      factoryArray: [],
      demoSelect: [],
      demoArray: [],
      allUserData: [],
      registerRole: 'Admin',
      role: ['Whole_Admin', 'Admin', 'OM_Head', 'Advance_User', 'Mid_User', 'Basic_User'],
      thTitle: [{
        text: '帳號',
        value: 'account'
      }, {
        text: '稱呼',
        value: 'displayName'
      }, {
        text: '可觀看案場',
        value: 'factoriesList'
      }, {
        text: '可觀看展示案場',
        value: 'demoList'
      }, {
        text: '權限',
        value: 'role'
      }, {
        text: '設定',
        value: ''
      }],
      account: '',
      password: '',
      passwordPlaceholder: '請輸入密碼',
      displayName: '',
      isUpdateAccount: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryInfo', 'roleArray', 'userDetail'])), {}, {
    minHeight: function minHeight() {
      var height = this.loadingData ? 'min-height: 75vh' : 'min-height: auto';
      return height;
    },
    factoryCheckBoxFilter: function factoryCheckBoxFilter() {
      var _this = this;
      return this.factoryArray.filter(function (x) {
        return x.match(_this.factoryCheckBoxFilterInput);
      });
    },
    demoCheckBoxFilter: function demoCheckBoxFilter() {
      var _this2 = this;
      return this.demoArray.filter(function (x) {
        return x.match(_this2.demoCheckBoxFilterInput);
      });
    },
    allUserDataLength: function allUserDataLength() {
      return this.allUserRoleFilter.length;
    },
    allUserRoleFilter: function allUserRoleFilter() {
      if (this.managerRole === 'Whole_Admin') {
        return this.allUserData;
      }
      return this.allUserData.filter(function (x) {
        return x.role !== 'Whole_Admin';
      });
    },
    // filterSelection () {
    //   return this.thTitle.filter((x) => x.text !== '設定')
    // },
    filterOptions: function filterOptions() {
      return this.thTitle.filter(function (x) {
        return x.text !== '設定';
      }).map(function (item) {
        return {
          text: item.text,
          value: item
        };
      });
    },
    allUserSearch: function allUserSearch() {
      var _this3 = this;
      if (this.selectedFilter.value === 'factoriesList') {
        return this.allUserRoleFilter.filter(function (x) {
          return x.factoriesList.toString().match(_this3.searchInput);
        });
      }
      if (this.selectedFilter.value === 'demoList') {
        return this.allUserRoleFilter.filter(function (x) {
          return x.demoList.toString().match(_this3.searchInput);
        });
      }
      return this.allUserRoleFilter.filter(function (x) {
        return x["".concat(_this3.selectedFilter.value)].match(_this3.searchInput);
      });
    },
    roleOption: function roleOption() {
      var roleOption = [];
      this.roleArray.forEach(function (x) {
        return roleOption.push(x.role);
      });
      if (this.managerRole === 'Whole_Admin') {
        return roleOption;
      } else if (this.managerRole === 'Admin') {
        return roleOption.filter(function (x) {
          return x !== 'Whole_Admin';
        });
      }
      return roleOption.filter(function (x) {
        return x !== 'Whole_Admin' && x !== 'Admin';
      });
    },
    roleOptions: function roleOptions() {
      var roleOption = [];
      this.roleArray.forEach(function (x) {
        return roleOption.push(x.role);
      });
      if (this.managerRole === 'Whole_Admin') {
        return roleOption.map(function (item) {
          return {
            value: item,
            text: item
          };
        });
      } else if (this.managerRole === 'Admin') {
        return roleOption.filter(function (x) {
          return x !== 'Whole_Admin';
        }).map(function (item) {
          return {
            value: item,
            text: item
          };
        });
      }
      return roleOption.filter(function (x) {
        return x !== 'Whole_Admin' && x !== 'Admin';
      }).map(function (item) {
        return {
          value: item,
          text: item
        };
      });
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), mapMutations(['UPDATE_ROLE_ARRAY', 'ADD_USER_DETAIL'])), {}, {
    openCreateUserModal: function openCreateUserModal() {
      this.account = '';
      this.password = '';
      this.displayName = '';
      this.registerRole = 'Admin';
      this.factorySelect = [];
      this.demoSelect = [];
      this.passwordPlaceholder = '請輸入密碼';
      this.isUpdateAccount = false;
      this.modalTitle = '新增帳號';
      this.isLoadingUpdate = false;
      this.$bvModal.show('userModal');
    },
    openEditUserModal: function openEditUserModal(account, displayName, role, factoryArr, demoArr, id) {
      this.account = account;
      this.displayName = displayName;
      this.factorySelect = factoryArr;
      this.demoSelect = demoArr;
      this.registerRole = role;
      this.id = id;
      this.isUpdateAccount = true;
      this.modalTitle = '編輯帳號';
      this.passwordPlaceholder = '若要修改，請輸入新密碼';
      this.isLoadingUpdate = false;
      this.$bvModal.show('userModal');
    },
    openFactoryCheckBox: function openFactoryCheckBox() {
      this.isOpenFactoryCheckBox = !this.isOpenFactoryCheckBox;
      this.isOpenDemoCheckBox = false;
    },
    openDemoCheckBox: function openDemoCheckBox() {
      this.isOpenDemoCheckBox = !this.isOpenDemoCheckBox;
      this.isOpenFactoryCheckBox = false;
    },
    roleLevel: function roleLevel(str) {
      if (str === 'Whole_Admin') return 6;
      if (str === 'Admin') return 5;
      if (str === 'OM_Head') return 4;
      if (str === 'Advance_User') return 3;
      if (str === 'Mid_User') return 2;
      if (str === 'Basic_User') return 1;
      if (str === 'unset') return 0;
      return null;
    },
    handleChangeFactorySelect: function handleChangeFactorySelect() {
      var lastSelectedItem = _toConsumableArray(this.factorySelect).pop();
      if (lastSelectedItem === '無') return this.factorySelect = ['無'];
      if (lastSelectedItem === 'ALL') return this.factorySelect = ['ALL'];
      this.factorySelect = this.factorySelect.filter(function (item) {
        return item !== '無' && item !== 'ALL';
      });
    },
    handleChangeDemoSelect: function handleChangeDemoSelect() {
      var lastSelectedItem = _toConsumableArray(this.demoSelect).pop();
      if (lastSelectedItem === '無') return this.demoSelect = ['無'];
      if (this.demoSelect.length > 5) {
        this.$swal('展示案場最多選擇 5 個');
        this.demoSelect = this.demoSelect.slice(0, 5);
      }
      this.demoSelect = this.demoSelect.filter(function (item) {
        return item !== '無';
      });
    },
    createUser: function createUser() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _createUser$data;
        var createUser;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this4.account === '')) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this4.$swal('請輸入帳號'));
              case 2:
                if (!(_this4.password === '')) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", _this4.$swal('請輸入密碼'));
              case 4:
                if (!(_this4.displayName === '')) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return", _this4.$swal('請輸入稱呼'));
              case 6:
                if (!(_this4.factorySelect.length === 0)) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return", _this4.$swal('請選擇 可觀看案場'));
              case 8:
                if (!(_this4.demoSelect.length === 0)) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return", _this4.$swal('請選擇 可觀看展示案場'));
              case 10:
                if (!(_this4.factorySelect[0] === '無' && _this4.demoSelect[0] === '無')) {
                  _context.next = 12;
                  break;
                }
                return _context.abrupt("return", _this4.$swal('至少選擇 1 個 觀看案場 或 展示案場'));
              case 12:
                if (!_this4.allUserData.map(function (obj) {
                  return obj.account;
                }).includes(_this4.account)) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return", _this4.$swal('帳號已被使用'));
              case 14:
                _this4.isLoadingUpdate = true;
                _context.next = 17;
                return createUserApi(_this4.operator, _this4.account, _this4.password, _this4.displayName, _this4.registerRole, _this4.factorySelect, _this4.demoSelect, _this4.operator);
              case 17:
                createUser = _context.sent;
                if (createUser !== null && createUser !== void 0 && (_createUser$data = createUser.data) !== null && _createUser$data !== void 0 && _createUser$data.success) {
                  _this4.$swal('創建成功');
                  _this4.account = '';
                  _this4.password = '';
                  _this4.displayName = '';
                  _this4.getAllusers();
                  _this4.isLoadingUpdate = false;
                  _this4.$bvModal.hide('userModal');
                } else {
                  _this4.$swal(createUser.data.msg);
                }
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getAllusers: function getAllusers() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _getAllusers$data;
        var getAllusers;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.loadingData = true;
                _context2.next = 3;
                return getAllUsersApi();
              case 3:
                getAllusers = _context2.sent;
                if (getAllusers !== null && getAllusers !== void 0 && (_getAllusers$data = getAllusers.data) !== null && _getAllusers$data !== void 0 && _getAllusers$data.success) {
                  _this5.allUserData = getAllusers.data.data.sort(function (x, y) {
                    return _this5.roleLevel(y.role) - _this5.roleLevel(x.role);
                  }).map(function (item) {
                    var _item$factoriesList, _item$demoList;
                    // factoriesList 或 demoList 至少會有 1 個
                    if (!item.factoriesList || ((_item$factoriesList = item.factoriesList) === null || _item$factoriesList === void 0 ? void 0 : _item$factoriesList.length) === 0) {
                      return _objectSpread(_objectSpread({}, item), {}, {
                        factoriesList: ['無']
                      });
                    }
                    if (!item.demoList || ((_item$demoList = item.demoList) === null || _item$demoList === void 0 ? void 0 : _item$demoList.length) === 0) {
                      return _objectSpread(_objectSpread({}, item), {}, {
                        demoList: ['無']
                      });
                    }
                    return item;
                  });
                  _this5.loadingData = false;
                }
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    updateUserInfo: function updateUserInfo() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var updateAccount, userDetail, _userDetail;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this6.displayName === '')) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return", _this6.$swal('請輸入稱呼'));
              case 2:
                if (!(_this6.factorySelect.length === 0)) {
                  _context3.next = 4;
                  break;
                }
                return _context3.abrupt("return", _this6.$swal('請選擇 可觀看案場'));
              case 4:
                if (!(_this6.demoSelect.length === 0)) {
                  _context3.next = 6;
                  break;
                }
                return _context3.abrupt("return", _this6.$swal('請選擇 可觀看展示案場'));
              case 6:
                if (!(_this6.factorySelect[0] === '無' && _this6.demoSelect[0] === '無')) {
                  _context3.next = 8;
                  break;
                }
                return _context3.abrupt("return", _this6.$swal('至少選擇 1 個 觀看案場 或 展示案場'));
              case 8:
                _this6.isLoadingUpdate = true;
                _context3.next = 11;
                return _this6.updateaccount();
              case 11:
                updateAccount = _context3.sent;
                if (_this6.operator === _this6.account) {
                  _this6.managerRole = _this6.registerRole;
                  _this6.$store.state.realTimeDataReload = true;
                  userDetail = JSON.parse(localStorage.getItem('userDetail'));
                  userDetail.account = _this6.account;
                  userDetail.displayName = _this6.displayName;
                  userDetail.factoriesList = _this6.factorySelect;
                  userDetail.demoList = _this6.demoSelect;
                  userDetail.role = _this6.registerRole;
                  userDetail.id = _this6.id;
                  localStorage.setItem('userDetail', JSON.stringify(userDetail));
                  _this6.UPDATE_ROLE_ARRAY();
                }
                if (!updateAccount) {
                  _context3.next = 28;
                  break;
                }
                _this6.$swal('更新成功');
                _this6.account = '';
                _this6.password = '';
                _this6.displayName = '';
                _this6.getAllusers();

                // store 更新使用者資訊
                _userDetail = JSON.parse(localStorage.getItem('userDetail'));
                _this6.ADD_USER_DETAIL(_userDetail);

                // 更新選擇選單
                _this6.factoryArray = [];
                _this6.demoArray = [];
                _context3.next = 25;
                return _this6.asyncInfo();
              case 25:
                _this6.factoryArray.push('無', 'ALL');
                _this6.demoArray.push('無');
                _this6.factoryInfo.forEach(function (x) {
                  if (!x.displaySiteName.includes('展示案場 ')) {
                    _this6.factoryArray.push(x.displaySiteName);
                    _this6.demoArray.push(x.displaySiteName);
                  }
                });
              case 28:
                _this6.isLoadingUpdate = false;
                _this6.$bvModal.hide('userModal');
              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    updateaccount: function updateaccount() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _updateaccount$data;
        var updateaccount;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.factorySelect = _this7.factorySelect.filter(function (x) {
                  return x !== '';
                });
                _context4.next = 3;
                return updateAccountApi(_this7.operator, _this7.id, _this7.account, _this7.password, _this7.displayName, _this7.registerRole, _this7.factorySelect, _this7.demoSelect);
              case 3:
                updateaccount = _context4.sent;
                if (!(updateaccount !== null && updateaccount !== void 0 && (_updateaccount$data = updateaccount.data) !== null && _updateaccount$data !== void 0 && _updateaccount$data.success)) {
                  _context4.next = 9;
                  break;
                }
                _this7.allUserData.forEach(function (x) {
                  if (x.account === _this7.account) {
                    x.factoriesList = _this7.factorySelect;
                    x.demoList = _this7.demoSelect;
                    x.role = _this7.registerRole;
                  }
                });
                return _context4.abrupt("return", true);
              case 9:
                _this7.$swal(updateaccount.data.msg);
                return _context4.abrupt("return", false);
              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    deleteUser: function deleteUser() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _deleteUser$data;
        var deleteUser;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return deleteUserApi(_this8.operator, _this8.id, _this8.account);
              case 2:
                deleteUser = _context5.sent;
                if (deleteUser !== null && deleteUser !== void 0 && (_deleteUser$data = deleteUser.data) !== null && _deleteUser$data !== void 0 && _deleteUser$data.success) {
                  _this8.$swal('刪除成功');
                  _this8.getAllusers();
                  _this8.$bvModal.hide('userModal');
                }
              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    checkDeleteUser: function checkDeleteUser() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.$swal.fire({
                  title: "\u78BA\u5B9A\u8981\u522A\u9664\u6B64\u4F7F\u7528\u8005?",
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: "\u78BA\u5B9A",
                  denyButtonText: "\u5426"
                }).then(function (result) {
                  if (result.isConfirmed) {
                    _this9.deleteUser();
                  }
                });
              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this10 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this10.operator = _this10.userDetail.account;
              _this10.managerRole = _this10.userDetail.role;
              _this10.getAllusers();
              _context7.next = 5;
              return _this10.asyncInfo();
            case 5:
              _this10.factoryArray.push('無', 'ALL');
              _this10.demoArray.push('無');
              _this10.factoryInfo.forEach(function (x) {
                if (!x.displaySiteName.includes('展示案場 ')) {
                  _this10.factoryArray.push(x.displaySiteName);
                  _this10.demoArray.push(x.displaySiteName);
                }
              });
            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
};